// ========================
// CURRENCY-AGNOSTIC MONEY HELPERS
// Reads amounts like "$199.00 AUD", "€95,85" or "-€10,00" in any market
// ========================
function parseMoneyText(text) {
  if (!text) return null;
  let str = String(text);
  const symbol = window.cartCurrencySymbol;
  if (symbol && str.indexOf(symbol) > -1) str = str.slice(str.indexOf(symbol));

  const match = str.match(/\d[\d.,]*/);
  if (!match) return null;

  const raw = match[0].replace(/[.,]+$/, '');
  const lastSep = Math.max(raw.lastIndexOf('.'), raw.lastIndexOf(','));
  let decimalSep = '.';
  let thousandsSep = ',';

  if (lastSep > -1) {
    const sepChar = raw[lastSep];
    const digitsAfter = raw.length - lastSep - 1;
    if (digitsAfter === 3) {
      thousandsSep = sepChar;
      decimalSep = sepChar === '.' ? ',' : '.';
    } else {
      decimalSep = sepChar;
      thousandsSep = sepChar === ',' ? '.' : ',';
    }
  }

  const value = parseFloat(raw.split(thousandsSep).join('').replace(decimalSep, '.'));
  if (isNaN(value)) return null;
  return { value, raw, decimalSep, thousandsSep };
}

function replaceMoneyAmount(text, parsed, newValue) {
  const parts = newValue.toFixed(2).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, parsed.thousandsSep);
  return String(text).replace(parsed.raw, parts.join(parsed.decimalSep));
}

// ========================
// REFRESH SIDE CART
// ========================
function refreshSideCart_cartjs() {
  fetch("/cart?section_id=cart-drawer")
  .then(res => res.text())
  .then(html => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const newDrawer = doc.querySelector("cart-drawer");
    if (!newDrawer) return;

    const totalQty = parseInt(newDrawer?.getAttribute("data-totalqty") || "0", 10);
    updateCartBubble(totalQty);

    const existingDrawer = document.querySelector("cart-drawer");
    if (!existingDrawer) return;

    const innerNew = newDrawer.querySelector('.drawer__inner');
    const innerCurrent = existingDrawer.querySelector('.drawer__inner');
    if (innerNew && innerCurrent) {
      innerCurrent.innerHTML = innerNew.innerHTML;
    }

    existingDrawer.classList.toggle("is-empty", totalQty === 0);
    existingDrawer.classList.add("active");

    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  });
}

// ========================
// CART OPERATION QUEUE
// cartOpStart and cartOpEnd are defined in cart.js with pendingCartOps counter.
// These stubs ensure no reference errors if custom.js executes first.
// ========================
if (typeof cartOpStart === 'undefined') {
  var cartOpStart = function() {};
}
if (typeof cartOpEnd === 'undefined') {
  var cartOpEnd = function() {};
}


// ========================
// MASTER CART UPDATE
// Call this after any add/remove. Handles gifts, shipping protection, then refreshes once.
// ========================
async function updateCartAndRefresh() {
  try {
    cartOpStart();
    const res = await fetch('/cart.js');
    const parsedState = await res.json();

    // Fix gifts
    await fixGifts(parsedState);

    // Fix shipping protection
    await fixShippingProtection_customjs(parsedState);

    // Refresh once at the end
    await refreshSideCart_cartjs();
  } catch(e) {
    console.error("Cart update error:", e);
  } finally {
    cartOpEnd();
  }
}

// ========================
// INITIALIZE CART SLIDER
// ========================
function initializeCartSlider() {
  const drawer = document.querySelector(".drawer__inner-complete-items");
  const swiperContainer = drawer?.querySelector(".cart-items.swiper");
  if (swiperContainer) {
    if (swiperContainer.classList.contains("swiper-initialized")) {
      swiperContainer.swiper.destroy(true, true);
    }
    new Swiper('.cart-items.swiper', {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      loop: false,
    });
  }
}

// ========================
// CART BUBBLE
// ========================
function updateCartBubble(totalQty) {
  const cartIcon = document.querySelector("#cart-icon-bubble");
  if (!cartIcon) return;

  const existingBubble = cartIcon.querySelector(".cart-count-bubble");
  if (existingBubble) existingBubble.remove();

  if (totalQty > 0) {
    cartIcon.insertAdjacentHTML("beforeend", `
      <div class="cart-count-bubble">
        <span aria-hidden="true">${totalQty}</span>
        <span class="visually-hidden">${totalQty} item${totalQty > 1 ? "s" : ""}</span>
      </div>
    `);
  }
}

// ========================
// GIFT PRODUCT ADD BTN (tier-based free gift)
// ========================
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".gift-product-add-btn");
  if (!btn) return;

  const row = btn.closest(".gift-product-item");
  const select = row
    ? row.querySelector(".gift-product-select, input[type='hidden'][id^='GiftProductSelect']")
    : null;
  const variantId = select ? select.value : btn.dataset.variantId;
  if (!variantId) return;

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  })
    .then(res => res.json())
    .then(() => updateCartAndRefresh())
    .catch(err => console.error("Error adding gift product:", err));
});

document.addEventListener("change", function (e) {
  const select = e.target.closest(".gift-product-select");
  if (!select) return;

  const cell = select.closest(".gift-product-cell");
  const btn = cell
    ? cell.querySelector(".gift-product-add-btn")
    : document.querySelector(".gift-product-add-btn");

  const imgUrl = select.selectedOptions?.[0]?.dataset?.imgurl || select.dataset.imgurl;
  if (imgUrl && imgUrl.trim() !== "") {
    const imgTarget = select.closest(".gift-product-item")?.querySelector(".gift-product-image img");
    if (imgTarget) imgTarget.src = imgUrl;
  }

  if (btn) btn.dataset.variantId = select.value;
});

// ========================
// BUNDLE ADD TO CART
// ========================
document.addEventListener("click", function (e) {
  const cartBtn = e.target.closest(".cart_button");
  if (!cartBtn) return;

  const mainContainer = cartBtn.closest('.bundle-summary');
  const spinner = cartBtn.querySelector('.loading__spinner');
  if (!mainContainer) return;

  const emptyContainers = mainContainer.querySelectorAll('.empty');
  if (emptyContainers.length > 0) {
    document.querySelector('.notify-wrapper')?.classList.add('error');
    return;
  }

  const productInfo = [];
  mainContainer.querySelectorAll('.bundle-item').forEach(productDetail => {
    const pro_info = productDetail.querySelector('.item-info');
    if (!pro_info) return;
    const pro_name = pro_info.querySelector('.item-title')?.textContent.trim() || '';
    const pro_size = pro_info.querySelector('.item-size')?.textContent.replace('Size:', '').trim() || '';
    productInfo.push(`${pro_name} - Size ${pro_size}`);
  });

  document.querySelector('.notify-wrapper')?.classList.remove('error');

  const bundleId = Number(cartBtn.dataset.bundleId);
  if (!bundleId) { console.error('Invalid variant ID'); return; }

  const bundlePriceContainer = cartBtn.closest('.bundle-footer');
  const priceElement = bundlePriceContainer?.querySelector('.new-price');
  // priceElement used for display only, not needed for add

  if (spinner) spinner.classList.remove('hidden');
  cartBtn.classList.add('custom-disable');

  const lineItemProperties = productInfo.reduce((acc, item, index) => {
    acc[`item-${index + 1}`] = item;
    return acc;
  }, {});

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify({ id: bundleId, quantity: 1, properties: { ...lineItemProperties } }),
  })
    .then(res => res.json())
    .then(() => updateCartAndRefresh())
    .catch(err => console.error("Error adding bundle product:", err))
    .finally(() => {
      if (spinner) spinner.classList.add('hidden');
      cartBtn.classList.remove('custom-disable');
    });
});

// ========================
// SHIPPING PROTECTION TOGGLE
// ========================
document.addEventListener('change', function (e) {
  const toggle = e.target.closest('#shippingProtectionToggle');
  if (!toggle) return;

  if (toggle.checked) {
    updateCartAndRefresh();
  } else {
    removeShippingProtection_customjs();
  }
});

// ========================
// GET CART AND FIX SHIPPING (kept for compatibility)
// ========================
async function getCartAndFixShippingProtection() {
  await updateCartAndRefresh();
}

// ========================
// FIX SHIPPING PROTECTION
// ========================
function getShippingProtectionData(cartTotal) {
  if (!window.shippingProtectionLevels) return null;
  for (const level of window.shippingProtectionLevels) {
    if (cartTotal <= level.max) return level;
  }
  return null;
}

async function fixShippingProtection_customjs(parsedState) {
  const cartTotal = (parsedState.total_price / 100).toFixed(2);
  const return_level_var = getShippingProtectionData(cartTotal);
  if (!return_level_var?.variant) {
    console.warn("No shipping protection level found");
    return;
  }

  const correctVariantId = return_level_var.variant;
  const matchedItems = parsedState.items.filter(
    item => item.product_id == window.shippingProtectionProduct
  );

  for (const item of matchedItems) {
    if (item.id != correctVariantId) {
      await fetch('/cart/change.js', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    }
  }

  const isCorrectInCart = matchedItems.some(item => item.id == correctVariantId);
  if (!isCorrectInCart) {
    await fetch('/cart/add.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: correctVariantId, quantity: 1 })
    });
  }
}

async function removeShippingProtection_customjs() {
  try {
    const res = await fetch('/cart.js');
    const parsedState = await res.json();
    const matchedItems = parsedState.items.filter(
      item => item.product_id == window.shippingProtectionProduct
    );
    for (const item of matchedItems) {
      await fetch('/cart/change.js', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    }
    await refreshSideCart_cartjs();
  } catch (e) {
    console.error("Error removing shipping protection:", e);
  }
}

// ========================
// FIX AUTO-ADD GIFTS
// ========================
async function fixGifts(parsedState) {
  const rows = document.querySelectorAll('tbody.gift-product-body tr[data-autoadd="true"]');
  if (!rows.length) return;

  const cartTotalCustom = parsedState.total_price / 100;
  const itemsToAdd = [];
  const itemsToRemove = [];

  rows.forEach(tr => {
    const autoProdId = parseInt(tr.getAttribute("data-prodid"));
    const autoProdThreshold = parseInt(tr.getAttribute("data-threeshhold"));
    if (!autoProdId || !autoProdThreshold) return;

    const freeProductInCart = parsedState.items.find(item => item.id === autoProdId);

    if (cartTotalCustom >= autoProdThreshold) {
      if (!freeProductInCart) {
        itemsToAdd.push({ id: autoProdId, quantity: 1 });
      } else if (freeProductInCart.quantity > 1) {
        itemsToRemove.push({ key: freeProductInCart.key, qty: 1 });
      }
    } else {
      if (freeProductInCart) {
        itemsToRemove.push({ key: freeProductInCart.key, qty: 0 });
      }
    }
  });

  // Tier 2 and tier 3 gifts — manually added, so remove them if the cart drops below threshold
  [
    { sel: '.gift-product-item.gift_product_tier2', idAttr: 'data-tier2prodid', thAttr: 'data-tier2threshold' },
    { sel: '.gift-product-item.gift_product_tier3', idAttr: 'data-tier3prodid', thAttr: 'data-tier3threshold' }
  ].forEach(function (tier) {
    const row = document.querySelector(tier.sel);
    if (!row) return;

    const prodId = parseInt(row.getAttribute(tier.idAttr) || '0');
    const threshold = parseFloat(row.getAttribute(tier.thAttr) || '0');
    if (!prodId || !threshold) return;

    if (cartTotalCustom < threshold) {
      const inCart = parsedState.items.find(item => item.product_id === prodId);
      if (inCart) itemsToRemove.push({ key: inCart.key, qty: 0 });
    }
  });

  if (itemsToAdd.length) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itemsToAdd })
    });
  }

  for (const item of itemsToRemove) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: item.qty })
    });
  }
}

// Legacy wrappers kept for any calls that still use old function names
function autoCheckGiftInCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(parsedState => fixGifts(parsedState))
    .catch(err => console.error('Error fetching cart:', err));
}

function addToCart(items) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  }).then(() => refreshSideCart_cartjs());
}

function updateFromCart(itemKey, qty) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: itemKey, quantity: qty })
  }).then(() => refreshSideCart_cartjs());
}

function removeMultipleItems(keys = []) {
  if (!keys.length) return;
  const updates = {};
  keys.forEach(key => updates[key] = 0);
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  })
    .then(res => res.json())
    .then(() => refreshSideCart_cartjs())
    .catch(err => console.error('Multi-remove failed:', err));
}

// ========================
// RELATED PRODUCT VARIANT PRICE UPDATE
// ========================
document.addEventListener("DOMContentLoaded", function () {
  function formatMoney(cents) {
    if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.shopCurrencyFormat || "${{amount}}");
    }
    return (cents / 100).toFixed(2);
  }

  document.addEventListener("change", function (e) {
    if (!e.target.classList.contains("rp-variant-select")) return;
    const wrapper = e.target.closest(".related-product");
    const priceDiv = wrapper?.querySelector(".rp-price");
    if (priceDiv) {
      const selectedOption = e.target.options[e.target.selectedIndex];
      priceDiv.textContent = formatMoney(selectedOption.dataset.price);
    }
  });

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".rp-add-btn");
    if (!btn) return;
    const wrapper = btn.closest(".related-product");
    const select = wrapper.querySelector(".rp-variant-select");
    const variantId = select ? select.value : null;
    if (!variantId) return;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(res => res.json())
      .then(() => updateCartAndRefresh())
      .catch(err => console.error("Add to cart error:", err));
  });
});

// ========================
// HOVER ADD TO CART (collection grid)
// ========================
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".variant-add-to-cart-on-hover-outer").forEach(wrapper => {
    const variantList = wrapper.querySelector(".on-hover-variant-list");
    const addToCartBtn = wrapper.querySelector(".add-to-cart-btn");
    if (!variantList || !addToCartBtn) return;

    const variantItems = variantList.querySelectorAll(".variant-item");

    variantItems.forEach(item => {
      item.addEventListener("click", () => {
        variantItems.forEach(i => i.classList.remove("selected"));
        item.classList.add("selected");
        item.insertAdjacentHTML("beforeend", `
          <div class="variant-add-cart-on-hover-loading__spinner">
            <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
              <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
            </svg>
          </div>`
        );
        addToCartBtn.setAttribute("data-addcart", item.dataset.variantId);
        addToCartBtn.click();
      });
    });

    addToCartBtn.addEventListener("click", () => {
      const selectedVariantId = addToCartBtn.getAttribute("data-addcart");
      if (!selectedVariantId) { alert("Please select a variant first."); return; }

      const spinner = addToCartBtn.querySelector(".variant-add-cart-on-hover-loading__spinner");
      if (spinner) spinner.classList.remove("hidden");

      fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
    })
      .then(res => res.json())
      .then(() => {
        if (spinner) spinner.classList.add("hidden");
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.add('active');
          cartDrawer.classList.remove('is-empty');
          const emptyEl = cartDrawer.querySelector('.drawer__inner-empty');
          if (emptyEl) emptyEl.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:200px;"><svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66" width="40" height="40"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path" stroke="currentColor"></circle></svg></div>';
        }
        const spinnerEl = addToCartBtn.closest(".variant-add-to-cart-on-hover-outer")
          ?.querySelector(".variant-add-cart-on-hover-loading__spinner");
        if (spinnerEl) spinnerEl.remove();
        updateCartAndRefresh();
      })
        .catch(err => {
          console.error("Add to cart failed:", err);
          if (spinner) spinner.classList.add("hidden");
          const spinnerEl = addToCartBtn.closest(".variant-add-to-cart-on-hover-outer")
            ?.querySelector(".variant-add-cart-on-hover-loading__spinner");
          if (spinnerEl) spinnerEl.remove();
        });
    });
  });
});

// ========================
// STICKY ADD TO CART (product page)
// ========================
document.addEventListener("DOMContentLoaded", () => {
  function handleStickyButtons() {
    const productButtons = document.querySelector(".default_product_page .product-form__buttons");
    if (!productButtons) return;
    const scrollY = window.scrollY || window.pageYOffset;
    if (scrollY <= 0) {
      document.body.classList.remove("stick-btn");
      productButtons.classList.remove("stick");
    } else {
      document.body.classList.add("stick-btn");
      productButtons.classList.add("stick");
    }
  }
  handleStickyButtons();
  window.addEventListener("scroll", handleStickyButtons, { passive: true });
});

// ========================
// FIND SIZE POPUP
// ========================
const trigger = document.querySelector(".find-fit");
const popup = document.querySelector(".product_find_size");

if (popup) {
  const closeBtn = popup.querySelector(".close");
  const overlay = popup.querySelector(".find-size-overlay");

  if (trigger) {
    trigger.addEventListener("click", () => {
      popup.classList.remove("hidden");
      document.body.classList.add("no-scroll");
    });
  }

  const closePopup = () => {
    popup.classList.add("hidden");
    document.body.classList.remove("no-scroll");
  };

  if (closeBtn) closeBtn.addEventListener("click", closePopup);
  if (overlay) overlay.addEventListener("click", closePopup);
}

setTimeout(() => {
  if (typeof window.initFindSize === "function") window.initFindSize();
}, 100);

// ========================
// COMPLETE THE LOOK — add to cart
// ========================
function bindCompleteTheSetButtons() {
  document.querySelectorAll('.complete_set_btn').forEach(function(btn) {
    btn.removeEventListener('click', handleCompleteSetClick);
    btn.addEventListener('click', handleCompleteSetClick);
  });
}

function handleCompleteSetClick(e) {
  e.stopPropagation();
  const btn = this;
  const card = btn.closest('.cts-card');
  if (!card) return;

  const selectEl = card.querySelector('.cts-card__size-select');
  const singleVariant = card.querySelector('.cts-single-variant');
  const variantId = selectEl ? selectEl.value : singleVariant ? singleVariant.value : null;

  if (!variantId) {
    if (selectEl) {
      selectEl.style.borderColor = 'red';
      setTimeout(() => selectEl.style.borderColor = '', 800);
    }
    return;
  }

  btn.textContent = 'ADDING...';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
  })
    .then(res => res.json())
    .then(() => updateCartAndRefresh())
    .catch(err => {
      console.error('Add to cart error:', err);
      btn.textContent = 'ADD';
      btn.disabled = false;
    });
}

document.addEventListener('DOMContentLoaded', bindCompleteTheSetButtons);

const ctsObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType !== 1) return;
      if (node.tagName === 'CART-DRAWER' || (node.querySelector && node.querySelector('.complete_set_btn'))) {
        setTimeout(bindCompleteTheSetButtons, 100);
      }
    });
  });
});

ctsObserver.observe(document.body, { childList: true, subtree: true });

// ========================
// DISCOUNT YARD TAG LAYOUT FIX
// ========================
function fixDiscountYardTags() {
  const wrapper = document.querySelector('.stack-discounts-tags-wrapper');
  if (wrapper) {
    wrapper.style.setProperty('display', 'flex', 'important');
    wrapper.style.setProperty('flex-direction', 'row', 'important');
    wrapper.style.setProperty('flex-wrap', 'wrap', 'important');
    wrapper.style.setProperty('gap', '6px', 'important');
  }
  document.querySelectorAll('.stack-discounts-tag').forEach(tag => {
    tag.style.setProperty('display', 'inline-flex', 'important');
    tag.style.setProperty('width', 'auto', 'important');
    tag.style.setProperty('flex', '0 0 auto', 'important');
    tag.style.setProperty('white-space', 'nowrap', 'important');
  });
}

document.addEventListener('DOMContentLoaded', fixDiscountYardTags);
setTimeout(fixDiscountYardTags, 1000);
setTimeout(fixDiscountYardTags, 2000);

const dyTagObserver = new MutationObserver(function() {
  fixDiscountYardTags();
});
dyTagObserver.observe(document.body, { childList: true, subtree: true });

// ========================
// STACKDISCOUNTS REINIT ON CART UPDATE
// ========================
let stackDiscountsReinitTimer = null;
document.addEventListener('cart:updated', function() {
  if (!window.StackDiscounts) return;
  clearTimeout(stackDiscountsReinitTimer);
  stackDiscountsReinitTimer = setTimeout(function() {
    if (!window.StackDiscounts) return;
    window.StackDiscounts.initStackDiscounts();
    window.StackDiscounts.initProductBundles();
    window.StackDiscounts.initProductLabels();
  }, 600);
});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('media-gallery').forEach(function (gallery) {
    const viewer = gallery.elements && gallery.elements.viewer;
    if (!viewer) return;
    const list = viewer.querySelector('.product__media-list');
    if (!list) return;

    function setFrameHeight() {
      const first = list.querySelector('.product__media-item[data-media-id]');
      if (first) list.style.setProperty('--media-gallery-frame-height', first.getBoundingClientRect().height + 'px');
    }
    setFrameHeight();
    window.addEventListener('resize', setFrameHeight);

    const items = Array.from(list.querySelectorAll('.product__media-item[data-media-id]'));

    // Keep the active image / thumbnail highlight in sync as the user free-scrolls
    let scrollTimeout;
    function updateActiveFromScroll() {
      // Only meaningful for the desktop vertical column. On mobile's horizontal
      // slider every item shares the same top, so this always picks image one.
      if (!window.matchMedia('(min-width: 750px)').matches) return;
      const listRect = list.getBoundingClientRect();
      let closest = items[0];
      let closestDist = Infinity;
      items.forEach(function (item) {
        const dist = Math.abs(item.getBoundingClientRect().top - listRect.top);
        if (dist < closestDist) { closestDist = dist; closest = item; }
      });
      if (!closest || closest.classList.contains('is-active')) return;
      items.forEach(function (item) { item.classList.remove('is-active'); });
      closest.classList.add('is-active');
      if (gallery.elements.thumbnails) {
        const thumb = gallery.elements.thumbnails.querySelector('[data-target="' + closest.dataset.mediaId + '"]');
        if (thumb) gallery.setActiveThumbnail(thumb);
      }
    }

    list.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActiveFromScroll, 100);
    }, { passive: true });

    // Clicking a thumbnail scrolls the strip to that image
    if (gallery.elements.thumbnails) {
      gallery.elements.thumbnails.querySelectorAll('[data-target]').forEach(function (thumbEl) {
        thumbEl.querySelector('button').addEventListener('click', function () {
          // Mobile keeps Dawn's native horizontal slider — a vertical scroll here
          // would cancel it and snap back to the first image.
          if (!window.matchMedia('(min-width: 750px)').matches) return;
          const target = items.find(function (item) { return item.dataset.mediaId === thumbEl.dataset.target; });
          if (!target) return;
          // Dawn's setActiveMedia() queues its own scrollTo() on this same list.
          // Waiting one tick lets that fire first, otherwise it cancels this animation.
          setTimeout(function () {
            const listRect = list.getBoundingClientRect();
            const itemRect = target.getBoundingClientRect();
            list.scrollTo({ top: list.scrollTop + (itemRect.top - listRect.top), behavior: 'smooth' });
          }, 0);
        });
      });
    }
  });
});
document.addEventListener('DOMContentLoaded', function () {
  var bar = document.getElementById('StickyFullATCBar');
  if (!bar) return;

  var mainAtcWrap = document.querySelector('.product-form__buttons');
  if (!mainAtcWrap) return;

  var productInfo = mainAtcWrap.closest('product-info');
  var scope = productInfo || document;
  var mainAtcBtn = scope.querySelector('button[name="add"]');
  var variantSelects = scope.querySelector('variant-selects');
  var stickyBtn = document.getElementById('StickyFullATCButton');
  var priceEl = document.getElementById('StickyFullATCPrice');

  if (!mainAtcBtn || !stickyBtn) return;

  function toggleBar() {
    var rect = mainAtcWrap.getBoundingClientRect();
    bar.classList.toggle('show', rect.bottom < 0);
  }
  toggleBar();
  window.addEventListener('scroll', toggleBar, { passive: true });
  window.addEventListener('resize', toggleBar);

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var currency = bar.dataset.currency || '';
    return '$' + amount + (currency ? ' ' + currency : '');
  }

  var addingResetTimeout;
  stickyBtn.dataset.originalText = stickyBtn.textContent.trim();

  stickyBtn.addEventListener('click', function () {
    if (mainAtcBtn.disabled || stickyBtn.disabled) return;
    stickyBtn.disabled = true;
    stickyBtn.textContent = 'ADDING...';
    mainAtcBtn.click();

    clearTimeout(addingResetTimeout);
    addingResetTimeout = setTimeout(function () {
      stickyBtn.textContent = stickyBtn.dataset.originalText;
      stickyBtn.disabled = false;
    }, 4000);
  });

  document.addEventListener('cart:updated', function () {
    clearTimeout(addingResetTimeout);
    stickyBtn.textContent = stickyBtn.dataset.originalText;
    stickyBtn.disabled = false;
  });

  bar.querySelectorAll('.sticky-full-atc-bar__pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (pill.disabled) return;
      var value = pill.dataset.optionValue;
      var currentVariantSelects = scope.querySelector('variant-selects');
      if (!currentVariantSelects) return;
      var inputs = currentVariantSelects.querySelectorAll('input[type="radio"], input[type="text"]');
      var realInput = null;
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === value) { realInput = inputs[i]; break; }
      }
      if (realInput) {
        // Optimistically show the click taking effect right away
        bar.querySelectorAll('.sticky-full-atc-bar__pill').forEach(function (p) {
          p.classList.toggle('is-selected', p === pill);
        });
        stickyBtn.disabled = true;

        var originalFocus = HTMLElement.prototype.focus;
        HTMLElement.prototype.focus = function (options) {
          originalFocus.call(this, Object.assign({}, options, { preventScroll: true }));
        };

        realInput.checked = true;
        realInput.dispatchEvent(new Event('change', { bubbles: true }));

        setTimeout(function () {
          HTMLElement.prototype.focus = originalFocus;
        }, 3000);
      }
    });
  });

  function syncBarFromVariant(variant) {
    if (!variant) return;

    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    bar.querySelectorAll('.sticky-full-atc-bar__pill').forEach(function (pill) {
      var position = parseInt(pill.dataset.optionPosition, 10);
      var value = pill.dataset.optionValue;
      var isSelected = variant.options && variant.options[position - 1] === value;
      pill.classList.toggle('is-selected', isSelected);
    });

    stickyBtn.disabled = !variant.available;
    stickyBtn.dataset.originalText = variant.available
      ? (window.variantStrings ? window.variantStrings.addToCart : 'Add to Bag')
      : (window.variantStrings ? window.variantStrings.soldOut : 'Sold Out');
    if (stickyBtn.textContent !== 'ADDING...') {
      stickyBtn.textContent = stickyBtn.dataset.originalText;
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      syncBarFromVariant(event.data.variant);
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  var MediaGalleryClass = customElements.get('media-gallery');
  if (MediaGalleryClass && MediaGalleryClass.prototype.onSlideChanged) {
    MediaGalleryClass.prototype.onSlideChanged = function (event) {
      if (!event.detail || !event.detail.currentElement || !event.detail.currentElement.dataset) return;
      var thumbnail = this.elements.thumbnails.querySelector(
        '[data-target="' + event.detail.currentElement.dataset.mediaId + '"]'
      );
      this.setActiveThumbnail(thumbnail);
    };
  }
});
// Fix: prevent media-gallery.js crash when gallery is in vertical scroll mode
document.addEventListener('DOMContentLoaded', function () {
  var MediaGalleryClass = customElements.get('media-gallery');
  if (MediaGalleryClass && MediaGalleryClass.prototype.onSlideChanged) {
    MediaGalleryClass.prototype.onSlideChanged = function (event) {
      if (!event.detail || !event.detail.currentElement || !event.detail.currentElement.dataset) return;
      if (!this.elements.thumbnails) return;
      var thumbnail = this.elements.thumbnails.querySelector(
        '[data-target="' + event.detail.currentElement.dataset.mediaId + '"]'
      );
      this.setActiveThumbnail(thumbnail);
    };
  }
});
// ========================
// COMPLETE THE LOOK (PDP) — standalone modal, no swatches, no shared quick-add component
// ========================
(function () {
  let activeVariantId = {};

  // Escape any transformed carousel ancestor by moving each modal to the
  // end of <body> the first time we see it, so `position: fixed` behaves
  // relative to the real viewport.
  function relocateCtlModals() {
    document.querySelectorAll('.ctl-modal[data-ctl-needs-move="true"]').forEach(function (modal) {
      modal.removeAttribute('data-ctl-needs-move');
      document.body.appendChild(modal);
    });
  }

  function openCtlModal(id) {
    const modal = document.getElementById(id);
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ctl-modal-open');
  }

  function closeCtlModal(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ctl-modal-open');
  }

  function bindCtlHandlers() {
    relocateCtlModals();

    document.querySelectorAll('[data-ctl-open]').forEach(function (btn) {
      if (btn.dataset.ctlBound) return;
      btn.dataset.ctlBound = 'true';
      btn.addEventListener('click', function () {
        openCtlModal(btn.getAttribute('data-ctl-open'));
      });
    });

    document.querySelectorAll('.ctl-modal').forEach(function (modal) {
      if (modal.dataset.ctlBound) return;
      modal.dataset.ctlBound = 'true';

      modal.querySelectorAll('[data-ctl-close]').forEach(function (closer) {
        closer.addEventListener('click', function () {
          closeCtlModal(modal);
        });
      });

      modal.querySelectorAll('.ctl-size-btn').forEach(function (sizeBtn) {
        if (sizeBtn.classList.contains('is-selected')) {
          activeVariantId[modal.id] = sizeBtn.getAttribute('data-variant-id');
        }
        if (sizeBtn.disabled) return;
        sizeBtn.addEventListener('click', function () {
          modal.querySelectorAll('.ctl-size-btn').forEach(function (b) {
            b.classList.remove('is-selected');
          });
          sizeBtn.classList.add('is-selected');
          activeVariantId[modal.id] = sizeBtn.getAttribute('data-variant-id');
        });
      });

const addBtn = modal.querySelector('.ctl-modal__add-btn');
      if (addBtn) {
        const addBtnText = addBtn.querySelector('.ctl-modal__add-btn-text');
        const originalText = addBtnText ? addBtnText.textContent : '';

        addBtn.addEventListener('click', function () {
          const variantId = activeVariantId[modal.id];
          if (!variantId) {
            const sizesWrap = modal.querySelector('.ctl-modal__sizes');
            if (sizesWrap) {
              sizesWrap.classList.add('ctl-shake');
              setTimeout(function () { sizesWrap.classList.remove('ctl-shake'); }, 500);
            }
            return;
          }
          addBtn.disabled = true;
          addBtn.classList.add('loading');
          if (addBtnText) addBtnText.textContent = 'ADDING...';
          const spinner = addBtn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
          })
            .then(function (res) { return res.json(); })
            .then(function () {
              closeCtlModal(modal);
              if (typeof updateCartAndRefresh === 'function') {
                updateCartAndRefresh();
              } else {
                location.reload();
              }
            })
            .catch(function (err) {
              console.error('Complete the Look add to cart error:', err);
            })
            .finally(function () {
              addBtn.disabled = false;
              addBtn.classList.remove('loading');
              if (addBtnText) addBtnText.textContent = originalText;
              if (spinner) spinner.classList.add('hidden');
            });
        });
      }
    });          // ← NEW: closes the .ctl-modal forEach callback
  }              // ← NEW: closes the bindCtlHandlers function

  document.addEventListener('DOMContentLoaded', bindCtlHandlers);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.ctl-modal.is-open').forEach(closeCtlModal);
  });

  const ctlObserver = new MutationObserver(function () { bindCtlHandlers(); });
  ctlObserver.observe(document.body, { childList: true, subtree: true });
})();

// ========================
// CART ADD-ON BLOCK — style switch + add to cart
// ========================
document.addEventListener('change', function (e) {
  const styleSelect = e.target.closest('.cart-addon__style-select');
  if (!styleSelect) return;

  const block = styleSelect.closest('.cart-addon');
  if (!block) return;

  const opt = styleSelect.options[styleSelect.selectedIndex];
  const productId = styleSelect.value;

  const img = block.querySelector('.cart-addon__image');
  if (img) img.src = opt.dataset.image;

  block.querySelectorAll('.cart-addon__link').forEach(function (link) {
    link.href = opt.dataset.url;
  });

  const title = block.querySelector('.cart-addon__title');
  if (title) title.textContent = opt.dataset.title;

  const priceNow = block.querySelector('.cart-addon__price-now');
  if (priceNow) priceNow.textContent = opt.dataset.price;

  const priceWas = block.querySelector('.cart-addon__price-was');
  if (priceWas) {
    if (opt.dataset.compare) {
      priceWas.textContent = opt.dataset.compare;
      priceWas.hidden = false;
    } else {
      priceWas.hidden = true;
    }
  }

  block.querySelectorAll('.cart-addon__size-select').forEach(function (sel) {
    const isMatch = sel.dataset.productId === productId;
    sel.hidden = !isMatch;
    if (isMatch) sel.selectedIndex = 0;
  });
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.cart-addon__add-btn');
  if (!btn) return;

  const block = btn.closest('.cart-addon');
  const select = block
    ? block.querySelector('.cart-addon__size-select:not([hidden])')
    : null;
  const variantId = select ? select.value : null;

  if (!variantId) {
    if (select) {
      select.classList.add('cart-addon__size-select--error');
      setTimeout(function () {
        select.classList.remove('cart-addon__size-select--error');
      }, 800);
    }
    return;
  }

  const originalText = btn.textContent;
  btn.textContent = 'ADDING...';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
  })
    .then(function (res) { return res.json(); })
    .then(function () { updateCartAndRefresh(); })
    .catch(function (err) {
      console.error('Cart add-on error:', err);
      btn.textContent = originalText;
      btn.disabled = false;
    });
});

document.addEventListener('change', function (e) {
  const select = e.target.closest('.gift-product-select');
  if (!select) return;

  const row = select.closest('.gift-product-item');
  if (!row) return;

  const img = row.querySelector('.gift-product-img');
  const option = select.options[select.selectedIndex];
  if (!img || !option) return;

  const url = option.dataset.imgurl;
  if (url && url !== 'null' && url.trim() !== '') {
    img.src = url;
  }
});

// ========================
// GIFT TIER LOCK SYNC (accounts for DiscountYard discount)
// ========================
function getDiscountedSubtotal() {
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const base = cart.total_price / 100;

      const discountEl = document.querySelector('.stack-discounts-discount-value');
      let discount = 0;
      if (discountEl) {
        const parsed = parseMoneyText(discountEl.textContent);
        if (parsed) discount = parsed.value || 0;
      }

      return Math.max(base - discount, 0);
    })
    .catch(() => null);
}

function syncGiftTierLocks() {
  console.log('[giftTierSync] running...');
  getDiscountedSubtotal().then(function (adjustedTotal) {
    console.log('[giftTierSync] adjustedTotal:', adjustedTotal);
    if (adjustedTotal === null) { console.log('[giftTierSync] bailed — null total'); return; }

    document.querySelectorAll('.gift-product-item').forEach(function (row) {
      const threshold = parseFloat(
        row.dataset.threeshhold || row.dataset.tier2threshold || row.dataset.tier3threshold
      );
      if (isNaN(threshold)) return;

      const unlocked = adjustedTotal >= threshold;
      console.log('[giftTierSync]', row.className, 'threshold:', threshold, 'unlocked:', unlocked);
      const btn = row.querySelector('.gift-product-add-btn');
      if (btn) btn.disabled = !unlocked;

      const titleEl = row.querySelector('[class*="__title"]');
      const firstLine = titleEl ? titleEl.querySelector('p:first-child') : null;
      if (firstLine) {
        firstLine.textContent = unlocked ? 'Free Gift Unlocked!' : 'Free Gift Locked!';
      }
    });
  });
}

// Run after page load and after every cart change, same cadence as the subtotal sync
[500, 1000, 1500, 2500].forEach(delay => setTimeout(syncGiftTierLocks, delay));
document.addEventListener('cart:updated', function () {
  [300, 800, 1500, 2500].forEach(delay => setTimeout(syncGiftTierLocks, delay));
});

(function () {
  var cfg = window.baiiaRCConfig;
  if (!cfg || !cfg.appKey || !cfg.products || !cfg.products.length) return;

  var root = document.querySelector('[data-baiia-rc]');
  var track = document.querySelector('[data-baiia-rc-track]');
  if (!root || !track) return;

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }

  function fmtDate(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    var p = function (n) { return String(n).padStart(2, '0'); };
    return p(d.getMonth() + 1) + '/' + p(d.getDate()) + '/' + String(d.getFullYear()).slice(2);
  }

  function resolveProduct(name, fallback) {
    var map = window.baiiaAllProducts || {};
    var match = map[name];
    if (match) {
      return { title: name, handle: match.handle, image: match.image };
    }
    return { title: name || fallback.title, handle: fallback.handle, image: fallback.image };
  }

  function fetchProduct(p) {
    var url = 'https://api-cdn.yotpo.com/v1/widget/' + cfg.appKey +
              '/products/' + p.id + '/reviews.json?per_page=150';
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var res = data.response || {};
        var reviews = res.reviews || [];
        var grouping = res.grouping_data || {};

        return reviews.map(function (rev) {
          var hidden = (cfg.hiddenImageIds || []).map(function (s) { return s.trim(); });
          var imgs = (rev.images_data || [])
            .filter(function (im) { return hidden.indexOf(String(im.id)) === -1; })
            .map(function (im) { return im.original_url || im.thumb_url; })
            .filter(Boolean);

          var grouped = grouping[String(rev.id)];
          var product = grouped
            ? resolveProduct(grouped.product_name, p)
            : { title: p.title, handle: p.handle, image: p.image };

          return {
            id: rev.id,
            name: (rev.user && rev.user.display_name) || 'Anonymous',
            verified: !!rev.verified_buyer,
            date: rev.created_at,
            title: rev.title || '',
            content: rev.content || '',
            score: rev.score || 0,
            images: imgs,
            product: product
          };
        });
      })
      .catch(function (e) {
        console.warn('[baiia-rc] fetch failed for', p.title, e);
        return [];
      });
  }

  function dailySeed() {
    var d = new Date();
    var key = d.getFullYear() + '' + (d.getMonth() + 1) + '' + d.getDate();
    var h = 0;
    for (var i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
    return h;
  }

  function seededRandom(seed) {
    var s = seed;
    return function () {
      s = (s * 1664525 + 1013904223) >>> 0;
      return s / 4294967296;
    };
  }

  function seededShuffle(arr, rng) {
    var out = arr.slice();
    for (var i = out.length - 1; i > 0; i--) {
      var j = Math.floor(rng() * (i + 1));
      var tmp = out[i];
      out[i] = out[j];
      out[j] = tmp;
    }
    return out;
  }

  function stars(n) {
    var out = '';
    for (var i = 1; i <= 5; i++) out += '<span class="baiia-rc__star' + (i <= n ? ' is-on' : '') + '">★</span>';
    return out;
  }

  function media(r) {
    var imgs = r.images.slice(0, 3);
    if (!imgs.length) imgs = [r.product.image];

    var mode = imgs.length === 1 ? 'single' : (imgs.length === 2 ? 'duo' : 'trio');

    var tiles = imgs.map(function (src, i) {
      return '<img class="baiia-rc__tile' + (i === 0 ? ' baiia-rc__tile--main' : '') +
             '" src="' + esc(src) + '" alt="' + esc(r.product.title) + '" loading="lazy">';
    }).join('');

    return '<div class="baiia-rc__media baiia-rc__media--' + mode + '">' + tiles + '</div>';
  }

  function card(r) {
    return '<article class="baiia-rc__card">' +
      '<header class="baiia-rc__meta">' +
        '<span class="baiia-rc__name">' + esc(r.name) +
          (r.verified ? '<span class="baiia-rc__verified">✓ Verified Buyer</span>' : '') +
        '</span>' +
        '<span class="baiia-rc__date">' + fmtDate(r.date) + '</span>' +
      '</header>' +
      '<div class="baiia-rc__stars">' + stars(r.score) + '</div>' +
      (r.title ? '<h3 class="baiia-rc__title">' + esc(r.title) + '</h3>' : '') +
      '<p class="baiia-rc__content">' + esc(r.content) + '</p>' +
      '<a class="baiia-rc__product" href="/products/' + esc(r.product.handle) + '">' +
        media(r) +
        '<span class="baiia-rc__product-name">' + esc(r.product.title) + '</span>' +
      '</a>' +
    '</article>';
  }

  Promise.all(cfg.products.map(fetchProduct)).then(function (batches) {
    var all = [];
    var seen = {};
    batches.forEach(function (b) {
      b.forEach(function (r) {
        if (seen[r.id]) return;
        seen[r.id] = true;
        all.push(r);
      });
    });

    var oneYearAgo = Date.now() - 365 * 86400000;

    var eligible = all
      .filter(function (r) {
        return r.images.length > 0 &&
               r.score >= cfg.minScore &&
               new Date(r.date).getTime() >= oneYearAgo;
      })
      .sort(function (a, b) { return new Date(b.date) - new Date(a.date); });

    var rng = seededRandom(dailySeed());
    var picked = seededShuffle(eligible, rng).slice(0, cfg.maxCards);

    if (!picked.length) {
      root.style.display = 'none';
      console.warn('[baiia-rc] no reviews with photos found');
      return;
    }

    track.innerHTML = picked.map(card).join('');
  });

  root.addEventListener('click', function (e) {
    var prev = e.target.closest('.baiia-rc__arrow--prev');
    var next = e.target.closest('.baiia-rc__arrow--next');
    if (!prev && !next) return;
    var first = track.querySelector('.baiia-rc__card');
    var step = first ? first.offsetWidth + 24 : 400;
    track.scrollBy({ left: next ? step : -step, behavior: 'smooth' });
  });
})();